import { projects } from "../data/projects";
import ProjectCard from "../components/portfolio/ProjectCard";
import Seo from "../components/portfolio/Seo";

export default function Work() {
  return (
    <div className="max-w-4xl mx-auto space-y-12" data-testid="work-page">
      <Seo
        title="Selected Work — StockMate, Storepilot & Brookly AI | Mehedi Hassain"
        description="Products designed and shipped by Mehedi Hassain: StockMate and Storepilot, retail apps live on Google Play, plus Brookly AI, an AI website builder concept."
        path="/projects"
      />
      <section className="text-left space-y-6 py-16">
        <h1 className="text-4xl md:text-5xl font-bold text-foreground">Selected Work</h1>
        <p className="text-lg text-muted-foreground">
          A selection of products I've designed and built around real users, problems and
          constraints.
        </p>
      </section>
      <section className="space-y-10" data-testid="work-grid">
        {projects.map((p, i) => (
          <ProjectCard key={p.id} project={p} index={i} />
        ))}
      </section>
    </div>
  );
}
